import { connect } from 'react-redux';

import { Dispatch } from '../../../common/state';
import { toggleTopPopup } from '../../state/hide_offer';

import { ITopPopupDispatchProps, TopPopup } from './';

export const TopPopupContainer = connect(
  undefined,
  (dispatch: Dispatch): ITopPopupDispatchProps => ({
    toggleTopPopup: (isOpened: boolean) => () => dispatch(toggleTopPopup(isOpened)),
  }),
)(TopPopup);
